module.exports = __webpack_public_path__ + "img/login_tab02_03.1a21d779.png";